import { Suspense, lazy } from 'react';

import type { EditBlockProps } from './EditBlock';
import { ToolBlock } from './ToolBlock';

/**
 * The lazy boundary in front of `EditBlock` and the line differ it imports
 * (spec 157 FR-011): a transcript with no editing calls never loads either.
 */
const EditBlock = lazy(() => import('./EditBlock'));

export function EditBlockLazy(props: EditBlockProps) {
  const { edit } = props;
  return (
    <Suspense
      fallback={
        // The block as it will be, minus its line counts. It is folded on
        // arrival either way, so the chunk landing only changes the size label.
        <ToolBlock
          title={edit.tool}
          summary={edit.workspacePath ?? edit.path}
          content={edit.copyText}
        />
      }
    >
      <EditBlock {...props} />
    </Suspense>
  );
}
